import React from 'react'

export default function HomeMonthItem({ data }) {
    return (
        <div className=' ml-[0.625rem] items-center    border-transparentWhite border-r mr-4'>
            {/* <div className='relative min-h-[7.88rem!important] min-w-[8.19rem!important] max-h-[7.88rem!important] max-w-[8.19rem!important] cursor-pointer w-fit h-fit'>
                <img src={data?.img} alt={data.section} className="min-h-[7.88rem!important] min-w-[8.19rem!important] object-cover rounded-[0.313rem] max-h-[7.88rem!important] max-w-[8.19rem!important]" />
                {
                    data?.video || data?.audio ?
                        <div className='absolute w-full h-full top-0 left-0 pr-1 pb-1 flex justify-end items-end'>
                            <img src={`/images/icons/play.svg`} alt="play" className='w-[2.13rem] h-[2.13rem]' />
                        </div> : ''

                }
                {
                    data?.post ?
                        <div className='absolute w-full h-full top-0 left-0 pr-1 pb-1 flex justify-end items-end'>
                            <img src={`/images/icons/post.svg`} alt="play" className='w-[2.13rem] h-[2.13rem]' />
                        </div> : ''
                }

            </div> */}

            {
                // if data is post open other website url
                data?.post ?
                    <a href={data?.post} target='_blank' rel="noreferrer" >
                        <div className='relative min-h-[7.88rem!important] min-w-[8.19rem!important] max-h-[7.88rem!important] max-w-[8.19rem!important] cursor-pointer w-fit h-fit'>
                            <img src={data?.img} alt={data.section} className="min-h-[7.88rem!important] min-w-[8.19rem!important] object-cover rounded-[0.313rem] max-h-[7.88rem!important] max-w-[8.19rem!important]" />
                            <div className='absolute w-full h-full top-0 left-0 pr-1 pb-1 flex justify-end items-end'>
                                <img src={`/images/icons/post.svg`} alt="play" className='w-[2.13rem] h-[2.13rem]' />
                            </div>

                        </div>
                    </a> :
                    // if data is other then post open popup 
                    // TODO add popup functional
                    <div className='relative min-h-[7.88rem!important] min-w-[8.19rem!important] max-h-[7.88rem!important] max-w-[8.19rem!important] cursor-pointer w-fit h-fit'>
                        <img src={data?.img} alt={data.section} className="min-h-[7.88rem!important] min-w-[8.19rem!important] object-cover rounded-[0.313rem] max-h-[7.88rem!important] max-w-[8.19rem!important]" />
                        <div className='absolute w-full h-full top-0 left-0 pr-1 pb-1 flex justify-end items-end'>
                            {
                                data?.video || data?.audio ?

                                    <img src={`/images/icons/play.svg`} alt="play" className='w-[2.13rem] h-[2.13rem]' />
                                    :
                                    < img src={`/images/icons/image-icon.svg`} alt="play" className='w-[2.13rem] h-[2.13rem]' />

                            }
                        </div>
                    </div>

            }
            <div className='font-dropdownFont font-medium tracking-wider text-xs leading-5 '>
                <div className='text-transparentWhite8 mt-3'>{data.section}</div>
                <div className='text-transparentWhite8'>{data.category}</div>
            </div>
        </div>
    )
}
